import { gql, useQuery } from '@apollo/client';
import { useApolloContext, useUserContext } from '../../../contexts';
import {
  GetCustomResourceTemplatesQuery,
  GetCustomResourceTemplatesQueryVariables,
} from './__generated__/useCustomResourceTemplates.generated';

const CUSTOM_RESOURCE_TEMPLATES_QUERY = gql`
  query GetCustomResourceTemplates($organizationID: ID!) {
    getCustomResourceTemplates(organizationID: $organizationID) {
      id
      resourceCategory
      resourceCategorySingular
      systemDefault
    }
  }
`;

export function useCustomResourceTemplates() {
  const { tenantId } = useApolloContext();
  const { currentUser } = useUserContext();

  const skip = !tenantId || !currentUser?.id;

  return useQuery<
    GetCustomResourceTemplatesQuery,
    GetCustomResourceTemplatesQueryVariables
  >(CUSTOM_RESOURCE_TEMPLATES_QUERY, {
    skip,
    variables: { organizationID: tenantId as string },
    fetchPolicy: 'cache-first',
    errorPolicy: 'ignore',
  });
}
